/**
所有主页菜单
author: 罗振
**/
<template>
  <div class="Search_box">
    <!-- 搜索 -->
    <transition name="fade">
      <div
        v-show="this.$props.isshow"
        :class="this.$store.getters.logoShow?'contentviews':'contentview'"
      >
        <el-input @change="submit" placeholder="搜索" v-model="searchValue" clearable>
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <!-- 最近访问 -->
        <div class="contone_box histor">
          <h3 id="contone">最近访问</h3>
          <ul>
            <li v-for="(el,index) in submenuList" :key="index">
              <span @click="toredirect(el)">{{el.fnName}}</span>
              <div :class="{collect:el.isCollection != 0}" @click="switCollect(el)"></div>
            </li>
          </ul>
        </div>
        <!-- 主体显示的内容 -->
        <div class="main">
          <div class="main_box" v-for="(el,index) in menusFunctionList" :key="index">
            <h3
              :id="'contone' +el.fnId"
              :class="el.fnBtns=='show'?'shaky':'ft14'"
              v-if="el.bool&&el.childNodes!=null"
            >{{el.fnName}}</h3>
            <ul>
              <li v-for="(item,dex) in el.childNodes" :key="dex">
                <div class="visible" v-if="item.isvisible == true || item.isvisible == undefined">
                  <span @click="toredirect(item)">{{item.fnName}}</span>
                  <div :class="{collect:item.isCollection != 0}" @click="switchCollect(item)"></div>
                </div>
              </li>
              <!-- v-if="item.isvisible" -->
            </ul>
          </div>
        </div>
        <!-- 切换菜单 -->
        <div class="tab" :class="this.$store.getters.logoShow?'tabShow':''">
          <a
            href="javascript:void(0)"
            v-for="(el,index) in menusFunctionList"
            :key="index"
            :class="{active:active==index}"
            @click="Tocont(el,index)"
          >
            <span>{{el.fnName}}</span>
          </a>
        </div>
      </div>
    </transition>
    <!-- 遮罩 -->
    <div @click="hide" v-show="this.$props.isshow" class="mask_layer"></div>
  </div>
</template>
<script>
import Vue from "vue";
import vuedraggable from "vuedraggable";
export default {
  name: "asideShow",
  components: { vuedraggable },
  props: {
    isshow: Boolean,
    getCollectionListInt: Function
  },
  data() {
    return {
      active: 0, //切换菜单栏
      searchValue: "",
      submenuList: [], //最近访问数据
      collectionList: [], //左侧菜单栏数据
      nowCollectionList: [], // 储存侧边栏数据
      menusFunctionList: [] //主体菜单
    };
  },
  methods: {
    // 切换菜单 定位
    Tocont(el, index) {
      let arr = [...this.menusFunctionList];
      for (let z in arr) {
        arr[z].fnBtns = "";
      }
      for (let i in arr) {
        if (el.fnName == arr[i].fnName) {
          arr[i].fnBtns = "show";
        }
      }
      this.active = index;
      document.querySelector("#contone" + el.fnId).scrollIntoView(true);
    },
    // 点击收藏 刷新列表
    switchCollect(item) {
      // console.log(item);
      if (item.isCollection != 0) {
        this.del(item);
      } else {
        this.added(item);
      }
      //新增最近浏览的功能记录
      this.request(
        this.Appconstance.REQUEST_TYPE.POST,
        this.adminApi.homerenovation.addErpFunctionBrowse,
        { fnId: item.fnId },
        false
      ).then(res => {});
    },
    // 最近访问 不刷新列表
    switCollect(item) {
      if (item.isCollection != 0) {
        this.del(item);
      } else {
        this.added(item);
      }
    },
    // 获取用户收藏 初始化数据
    collectionListInt() {
      this.request(
        this.Appconstance.REQUEST_TYPE.POST,
        this.adminApi.homerenovation.getUserCollcetionFunction,
        {},
        false
      ).then(res => {
        this.collectionList = res.rows;
        // 克隆对象
        this.nowCollectionList = this.StringUtil.cloneObj(res.rows);
      });
      this.request(
        this.Appconstance.REQUEST_TYPE.POST,
        this.adminApi.homerenovation.showBrowseList,
        {
          offset: 0,
          limit: 6
        },
        false
      ).then(res => {
        var arr = [];
        res.rows.forEach(el => {
          arr.push(el);
        });
        this.submenuList = arr;
      });
      let arr = this.$store.state.userInfo.mapInfo.menusFunction;
      arr.forEach(el => {
        if (!el.bool) {
          el.bool = true;
        }
        if (el.childNodes != null) {
          el.childNodes.forEach(it => {
            if (this.collectionList.length != 0 && it.isCollection != 0) {
              this.collectionList.forEach(item => {
                if (item.fnName == it.fnName) {
                  it.isCollection = item.isCollection;
                }
              });
            }
          });
        }
      });
      this.menusFunctionList = arr.filter(el => {
        return el.childNodes != null;
      });
    },
    // 删除列表 取消收藏
    del(item) {
      this.request(
        this.Appconstance.REQUEST_TYPE.POST,
        this.adminApi.homerenovation.delByModel + item.fnId,
        {},
        false,
        false
      ).then(res => {
        if (res.status == 200) {
          var arr = this.$store.state.userInfo.mapInfo.menusFunction;
          for (let i = 0, l = arr.length; i < l; i++) {
            if (arr[i].childNodes != null) {
              arr[i].childNodes.forEach((it, index) => {
                if (it.fnName == item.fnName) {
                  item.isCollection = it.isCollection = 0;
                }
              });
            }
          }
          this.$store.state.userInfo.mapInfo.menusFunction = arr;
          this.collectionListInt();
          this.$emit("getCollectionListInt");
        }
      });
    },
    // 添加列表 新增收藏
    added(item) {
      this.request(
        this.Appconstance.REQUEST_TYPE.POST,
        this.adminApi.homerenovation.addErpFunctionCollection,
        { fnId: item.fnId },
        false
      ).then(res => {
        if (res.status == 200) {
          let arr = this.$store.state.userInfo.mapInfo.menusFunction;
          for (let i = 0, l = arr.length; i < l; i++) {
            if (arr[i].childNodes != null) {
              arr[i].childNodes.forEach((it, index) => {
                if (item.fnName == it.fnName) {
                  item.isCollection = it.isCollection = res.mapInfo.insert.id;
                }
              });
            }
          }
          this.$store.state.userInfo.mapInfo.menusFunction = arr;
          this.collectionListInt();
          this.$emit("getCollectionListInt");
        }
      });
    },
    // 搜索功能
    submit() {
      let arry = [...this.menusFunctionList];
      for (let i = 0, l = arry.length; i < l; i++) {
        let arr = arry[i].childNodes,
          num = 0,
          sum = 1;
        if (arr != null) {
          for (let j = 0; j < arr.length; j++) {
            if (arr[j].fnName.indexOf(this.searchValue) != -1) {
              num = 1;
              Vue.set(arr[j], "isvisible", true);
            } else {
              sum = 0;
              Vue.set(arr[j], "isvisible", false);
            }
          }
        }
        if (num == 0 && sum == 0) {
          arry[i].bool = false;
        } else {
          arry[i].bool = true;
        }
      }
      // this.menusFunctionList = arry;
      this.menusFunctionList = arry.filter(el => {
        return el.childNodes != null;
      });
    },
    // 隐藏菜单栏
    hide() {
      this.$eventHub.$emit("toshow", { bool: false });
    },
    // 路由跳转
    toredirect(item) {
      this.request(
        this.Appconstance.REQUEST_TYPE.POST,
        this.adminApi.homerenovation.addErpFunctionBrowse,
        { fnId: item.fnId },
        false
      ).then(res => {
        this.collectionListInt();
        this.$eventHub.$emit("toshow", { bool: false });
        this.$router.history.push({
          path: item.fnPath
        });
      });
    },
    // 拖拽结束后的方法
    datadragEnd(e) {
      var obj = {};
      this.nowCollectionList.forEach((el, index) => {
        if (e.oldIndex == index) {
          obj.oldCollectionId = el.collectionId;
          obj.oldSort = el.collectionSort;
        } else if (e.newIndex == index) {
          obj.newCollectionId = el.collectionId;
          obj.newSort = el.collectionSort;
        }
      });
      this.request(
        this.Appconstance.REQUEST_TYPE.POST,
        this.adminApi.homerenovation.modifyFunctionCollSort,
        obj,
        false
      ).then(res => {
        this.collectionListInt();
      });
    }
  },
  mounted() {
    this.collectionListInt();
  },
  watch: {
    isshow(val) {
      if (!val) {
        this.searchValue = "";
        this.submit();
      }
    }
  }
};
</script>
<style scoped>
.shaky {
  display: inline-block;
  font-size: 20px;
  transition: 0.5s linear;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
  transform-origin: center center;
  -webkit-animation-name: shaky-slow;
  -ms-animation-name: shaky-slow;
  animation-name: shaky-slow;
  -webkit-animation-duration: 0.5s;
  -ms-animation-duration: 0.5s;
  animation-duration: 0.5s;
  -webkit-animation-iteration-count: 1;
  -ms-animation-iteration-count: 1;
  animation-iteration-count: 1;
  -webkit-animation-timing-function: 0.5s;
  -ms-animation-timing-function: 0.5s;
  animation-timing-function: 0.5s;
  -webkit-animation-delay: 0s;
  -ms-animation-delay: 0s;
  animation-delay: 0s;
  -webkit-animation-play-state: running;
  -ms-animation-play-state: running;
  animation-play-state: running;
}
@keyframes shaky-slow {
  0% {
    transform: translate(0px, 0px) rotate(0deg);
  }
  20% {
    transform: translate(6px, 0px);
  }
  40% {
    transform: translate(-4px, 0px);
  }
  60% {
    transform: translate(6px, 0px);
  }
  80% {
    transform: translate(-4px, 0px);
  }
  100% {
    transform: translate(0px, 0px) rotate(0deg);
  }
}
.ft14 {
  font-size: 14px;
  transition: 0.5s linear;
}
.smenu-enter {
  opacity: 0;
  transform: translateX(200px);
}
.smenu-enter-active {
  transition: all 0.5s cubic-bezier(0, 0, 0.2, 1);
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translate3d(0px);
}
.fade-enter-active {
  transition: all 1s cubic-bezier(0.3, 0.02, 0.7, 0.99);
}
.fade-leave-active {
  transition: all 0.6s cubic-bezier(0.3, 0.02, 0.7, 0.99);
}
.Search_box {
  background-color: #f4f9ff;
  position: fixed;
  top: 60px;
  bottom: 0;
  left: 0;
  z-index: 9999;
}
.logo {
  background-color: #409eff;
  width: 200px;
}
.mask_layer {
  visibility: visible;
  opacity: 0.5;
  position: absolute;
  background: rgba(48, 49, 51, 1);
  width: 100vw;
  height: 100vh;
  z-index: 9997;
}
.sortable-ghost {
  line-height: 40px;
  height: 40px;
}
/* chosenClass: 设置被选中的元素的class */
.sortable-chosen {
  cursor: move;
}

.sortable-chosen span,
.sortable-chosen i,
.sortable-chosen em {
  color: #409eff;
}
/* dragClass:拖动元素的class。  */
.sortable-drag {
  line-height: 40px;
  height: 40px;
  background-color: rgba(125, 197, 255, 0.993);
}
.sortable-drag span,
.sortable-drag i,
.sortable-drag em {
  color: rgba(255, 255, 255, 0.7);
}
.contentview {
  overflow: hidden;
  overflow-y: auto;
  height: 100%;
  width: 960px;
  position: absolute;
  left: 200px;
  z-index: 9998;
  padding: 0 20px;
  background-color: #f4f9ff;
}
h3 {
  font-size: 14px;
  color: rgba(48, 49, 51, 1);
  margin-bottom: 10px;
  margin-left: 10px;
  text-align: left;
}
.contentview >>> .el-input__inner {
  padding-left: 40px;
  border: none;
  border-bottom: 1px solid #dedede;
  width: 685px;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  color: #595959;
  margin-bottom: 10px;
  background-color: #f4f9ff;
}
.contentview >>> .el-input__prefix {
  top: -4px;
}
.contentview >>> .el-input__suffix {
  left: 450px;
}
.contone_box {
  margin-bottom: 10px;
  width: 100%;
}
.contone_box ul {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.contone_box ul li {
  width: 20%;
  margin-right: 10%;
  height: 25px;
  line-height: 25px;
  color: #303133;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  position: relative;
}
.histor {
  margin-bottom: 20px;
}
.contone_box ul li span {
  display: inline-block;
  width: 100%;
}
.contone_box ul li div {
  width: 14px;
  height: 25px;
  position: absolute;
  right: 9px;
}
.contentview .contone_box li:hover {
  background: #ccc url("../../../../static/images/星级.png") no-repeat;
  background-size: 14px 14px;
  background-position: 94% center;
}
.main {
  column-count: 3;
  column-width: 200px;
  column-gap: 12px;
  margin-bottom: 12px;
  padding-right: 10%;
}
.main .main_box {
  display: inline-block;
  margin-bottom: 20px;
  width: 100%;
  break-inside: avoid;
}
.main .main_box ul li .visible {
  width: 70%;
  margin-right: 10%;
  height: 25px;
  line-height: 25px;
  color: #303133;
  font-size: 12px;
  cursor: pointer;
  padding: 0 10px;
  position: relative;
  display: flex;
  justify-content: space-between;
}
.main .main_box ul li .visible span {
  display: inline-block;
  width: 100%;
}
.main .main_box ul li .visible div {
  width: 14px;
  height: 25px;
  position: absolute;
  right: 10px;
}
.main .main_box ul li .visible:hover {
  background: #ccc url("../../../../static/images/星级.png") no-repeat;
  background-size: 14px 14px;
  background-position: 94% center;
}
.tab {
  top: 133px;
  left: 1000px;
  /* overflow-y: auto; */
  border-left: 1px solid #dedede;
  position: fixed;
  z-index: 88888;
  background-color: #f4f9ff;
}
.tabShow {
  left: 888px;
}
.tab a {
  display: block;
  text-align: left;
  width: 100%;
  height: 25px;
  line-height: 25px;
  padding-left: 5px;
  font-size: 14px;
  color: #303133;
  margin-bottom: 10px;
}
.tab a:hover {
  color: #409eff;
  border-left: 1px solid #409eff;
  background: rgba(224, 239, 255, 1);
}
.tab .active {
  color: #409eff;
  border-left: 1px solid #409eff;
  background-color: #e0efff;
}
.collect {
  background: url("../../../../static/images/实星.png") no-repeat center;
  background-size: 14px 14px;
}
.contentviews {
  overflow: hidden;
  overflow-y: auto;
  height: 100%;
  width: 960px;
  position: absolute;
  left: 64px;
  z-index: 9998;
  padding: 0 20px;
  background-color: #f4f9ff;
}
.contentviews >>> .el-input__inner {
  padding-left: 40px;
  border: none;
  border-bottom: 1px solid #dedede;
  width: 685px;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  color: #595959;
  margin-bottom: 10px;
  background-color: #f4f9ff;
}
.contentviews >>> .el-input__prefix {
  top: -4px;
}
.contentviews >>> .el-input__suffix {
  left: 450px;
}
</style>


// WEBPACK FOOTER //
// src/views/layout/aside/asideShow.vue